'use client';

import React from 'react';
import { Search, BarChart3, Sparkles, Globe, ArrowRight, Gift } from "lucide-react";
import Link from 'next/link';

const FreeTools = () => {
    const tools = [
        {
            icon: Search,
            name: "Long-Tail Keyword Generator",
            description: "Find low-competition keywords instantly",
            tag: "Most Popular",
            link: "https://www.seozast.com/keyword-generator"
        },
        {
            icon: BarChart3,
            name: "SEO Analyzer",
            description: "Get shareable X cards with your SEO score",
            tag: "Shareable",
            link: "https://www.seozast.com/seo-analyzer"
        },
        {
            icon: Sparkles,
            name: "AI Search Analyzer",
            description: "See how ChatGPT & Perplexity see your content",
            tag: "New",
            link: "https://www.seozast.com/aisearch-analyzer"
        }
    ];

    return (
        <section className="py-12 bg-gray-50">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* Header */}
                <div className="text-center mb-8">
                    <div className="inline-flex items-center gap-2 text-white bg-purple-600 px-3 py-1.5 rounded-full text-sm font-semibold mb-3">
                        <Gift className="w-4 h-4" />
                        No Signup Required
                    </div>
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
                        Free SEO Tools
                    </h2>
                    <p className="text-gray-600">
                        Try before you buy. No credit card. No commitment.
                    </p>
                </div>

                {/* Tools Grid - 3 tools */}
                <div className="grid md:grid-cols-3 gap-4 mb-6">
                    {tools.map((tool, index) => {
                        const IconComponent = tool.icon;
                        return (
                            <Link
                                key={index}
                                href={tool.link}
                                className="bg-white rounded-lg p-5 border border-gray-200 hover:border-purple-300 hover:shadow-md transition-all duration-200 group block"
                            >
                                <div className="flex items-start justify-between mb-3">
                                    <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center group-hover:bg-purple-200 transition-colors">
                                        <IconComponent className="w-5 h-5 text-purple-600" />
                                    </div>
                                    <span className="text-xs font-semibold text-purple-600 bg-purple-50 px-2 py-1 rounded">
                                        {tool.tag}
                                    </span>
                                </div>
                                <h3 className="text-base font-bold text-gray-900 mb-1 group-hover:text-purple-600 transition-colors">
                                    {tool.name}
                                </h3>
                                <p className="text-sm text-gray-600 mb-3">
                                    {tool.description}
                                </p>
                                <div className="flex items-center text-purple-600 text-sm font-semibold group-hover:gap-2 transition-all">
                                    Try it now
                                    <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
                                </div>
                            </Link>
                        );
                    })}
                </div>

                {/* Bottom note */}
                <div className="text-center my-8">
                    <p className="text-md text-gray-600">
                        💡 All tools are free forever. Share your results on X and go viral 🚀
                    </p>
                </div>

                {/* Directory - Destacado aparte */}
                <div className="bg-gradient-to-r border border-gray-200 hover:border-purple-300 from-purple-60 to-cyan-60 rounded-xl p-6">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        <div className="flex items-start gap-4">
                            <div className="w-12 h-12 bg-purple-100 text-purple-600 rounded-lg flex items-center justify-center flex-shrink-0">
                                <Globe className="w-6 h-6" />
                            </div>
                            <div>
                                <div className="inline-flex items-center gap-2 bg-purple-100 text-purple-600 px-2 py-1 rounded text-xs font-semibold mb-2">
                                    <span>✨</span> Explore
                                </div>
                                <h3 className="text-xl font-bold mb-1">
                                    Website Directory
                                </h3>
                                <p className="text-sm">
                                    Discover websites optimized for AI search and get inspired by real examples
                                </p>
                            </div>
                        </div>
                        <Link
                            href="https://www.seozast.com/directory"
                            className="inline-flex items-center justify-center bg-white text-purple-600 font-semibold py-3 px-6 rounded-lg hover:bg-purple-50 transition duration-300 whitespace-nowrap"
                        >
                            Browse Directory
                            <ArrowRight className="w-4 h-4 ml-2" />
                        </Link>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default FreeTools;